var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 用户ID： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.user_id,
      expression: "condition.user_id"
    }],
    domProps: {
      "value": _vm.condition.user_id
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "user_id", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 礼品编号： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.gift_id,
      expression: "condition.gift_id"
    }],
    domProps: {
      "value": _vm.condition.gift_id
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "gift_id", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 礼品类型： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.gift_type,
      expression: "condition.gift_type"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "gift_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(" 全部 ")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 电报原生 ")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 电报NFT ")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" 其他 ")])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 发放状态： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.gift_status,
      expression: "condition.gift_status"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "gift_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待发放")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已发放")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已回收")])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 处理状态： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.status,
      expression: "condition.status"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待处理")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("处理中")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已处理")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("处理失败")])])]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.activity_id) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.user_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.username) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.gift_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.owner_gift_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_name) + " ")]), _c('div', {
      staticClass: "s icon"
    }, [item.gift_thumb ? _c('img', {
      attrs: {
        "src": item.gift_thumb,
        "height": "30px"
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.gift_stars) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.recycling_stars) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.gift_type == 0 ? '电报原生' : "" + item.gift_type == 1 ? '电报NFT' : '其他') + " ")]), _c('div', {
      staticClass: "s status",
      class: `status_${item.gift_status > 0 ? 2 : 0}`
    }, [_vm._v(" " + _vm._s(item.gift_status == 0 ? '待发放' : '' + item.gift_status == 1 ? '已发放' : '已回收') + " ")]), _c('div', {
      staticClass: "s status",
      class: `status_${item.status}`
    }, [_vm._v(" " + _vm._s(item.status == 0 ? '待处理' : '' + item.status == 1 ? '处理中' : "" + item.status == 2 ? '已处理' : '处理失败') + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.status_msg) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [item.gift_type == 1 && item.gift_status == 0 && (item.status == 0 || item.status == 3) || item.gift_type == 0 && item.status == 3 ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onSend(item);
        }
      }
    }, [_vm._v("发放")]) : _vm._e()])]);
  })], 2), _c('div', {
    staticClass: "data-bd"
  }, [_c('my-pagination', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.condition.limit,
      "page": _vm.condition.page,
      "on-page-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _c('pop-send-gift', {
    attrs: {
      "show": _vm.popGitfShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGitfShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" ID ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 活动ID ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 用户编号 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 电报账户 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 礼品编号 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 礼品原始ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 原始NFT名称 ")]), _c('div', {
    staticClass: "s icon"
  }, [_vm._v(" ICON ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 星星价值 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 回收星星 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 礼品类型 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 发放状态 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 状态 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 处理反馈 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 添加时间 ")]), _c('div', {
    staticClass: "s opt"
  })]);
}];
export { render, staticRenderFns };